/* eslint-disable camelcase */

import type { IssuesMap } from '../../common/utils/use-issues-map.tsx';
import type { TimelineViewIssue } from '../get-timeline-view-issues/types.tsx';
import type {
	CreateJWMDependencyTimelineView_linkJwmItems,
	CreateJWMDependencyTimelineView_linkJwmItems_outwardItem_issueLinks_edges_node as IssueLinksNode,
} from './__generated_apollo__/CreateJWMDependencyTimelineView';

const OPTIMISTIC_ID_PREFIX = 'optimistic-issuelink-id-';

export const createOptimisticLinkItems = ({
	inwardIssueId,
	outwardIssueId,
	issuesMap,
}: {
	inwardIssueId: string;
	outwardIssueId: string;
	issuesMap: IssuesMap;
}): CreateJWMDependencyTimelineView_linkJwmItems => ({
	inwardItem: {
		issueId: Number(inwardIssueId),
		issueLinks: {
			edges: [
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				...((issuesMap.get(inwardIssueId) as TimelineViewIssue)?.originalIssueLinks || []),
				{
					node: {
						issue: {
							issueId: outwardIssueId,
							__typename: 'JiraIssue',
						},
						issueLinkId: `${OPTIMISTIC_ID_PREFIX}${outwardIssueId}`,
						relationName: 'is blocked by',
						// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
						direction: 'OUTWARD' as IssueLinksNode['direction'],
						__typename: 'JiraIssueLink',
					},
					__typename: 'JiraIssueLinkEdge',
				},
			],
			__typename: 'JiraIssueLinkConnection',
		},
		__typename: 'JiraWorkManagementViewItem',
	},
	outwardItem: {
		issueId: Number(outwardIssueId),
		issueLinks: {
			edges: [
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				...((issuesMap.get(outwardIssueId) as TimelineViewIssue)?.originalIssueLinks || []),
				{
					node: {
						issue: {
							issueId: inwardIssueId,
							__typename: 'JiraIssue',
						},
						issueLinkId: `${OPTIMISTIC_ID_PREFIX}${inwardIssueId}`,
						relationName: 'blocks',
						// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
						direction: 'INWARD' as IssueLinksNode['direction'],
						__typename: 'JiraIssueLink',
					},
					__typename: 'JiraIssueLinkEdge',
				},
			],
			__typename: 'JiraIssueLinkConnection',
		},
		__typename: 'JiraWorkManagementViewItem',
	},
	success: true,
	errors: null,
	__typename: 'JWMLinkItemsPayload',
});
